import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadCompany, clearCompany } from '../../common/companies/actions'
import { Title } from '../components'
import { CompanyForm } from '../forms'

class CompanyPage extends React.Component {
  componentDidMount() {
    const { match, loadCompany, company } = this.props
    const { params } = match
    if (params.company && (!company._id || params.company !== company._id)) {
      loadCompany(params.company)
    }
  }
  componentWillUnmount() {
    this.props.clearCompany()
  }
  render() {
    const { match, company } = this.props
    const { params } = match
    let companyForm = null
    if (params.company) {
      if (company._id) companyForm = <CompanyForm company={company} />
    } else {
      companyForm = <CompanyForm />
    }
    const title = company._id ? company.name : 'Nový dopravce'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/companies">Dopravci</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
        </aside>
        <main className="form-page thin">
          {companyForm}
        </main>
      </div>
    )
  }
}

CompanyPage.propTypes = {
  match: React.PropTypes.object.isRequired,
  company: React.PropTypes.object.isRequired,
  loadCompany: React.PropTypes.func.isRequired,
  clearCompany: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  company: state.companies.current,
}), { loadCompany, clearCompany })(CompanyPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Company.js